import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";


@Injectable()
export class UserMgmtService {
  constructor(private _networkService: NetworkService) {}

  getUserListApi(query) {
    return this._networkService.get(
      "api/user/userList/admin?registerType=user"+query,
      null,
      null,
      "bearer"
    );
  }
  getUserListStaatusApi(query) {
    return this._networkService.get(
      "api/user/userList?"+query,
      null,
      null,
      "bearer"
    );
  }

  
  getUserVideoListApi(query) {
    return this._networkService.get(
      "api/playList/admin?" + query,
      null,
      null,
      "bearer"
    );
  }
  getCompanyUserList(query) {
    return this._networkService.get(
      "api/user/userList/admin?registerType=company&"+ query,
      null,
      null,
      "bearer"
    );
  }
  
  updateUserStatus(user: any) {
    return this._networkService.put("api/user", user, null, "bearer");
  }
  kudoCredit(user: any) {
    return this._networkService.post("api/admin/kudo", user, null, "bearer");
  }
  clapHistory(req: any) {
    return this._networkService.get("api/clap?"+req, null, null, "bearer");
  }
  clapCredit(user: any) {
    return this._networkService.post("api/admin/clap", user, null, "bearer");
  }
  kudoHistory(req: any) {
    return this._networkService.get("api/kudo?"+req, null, null, "bearer");
  }
  getDashboardCountUser() {
    return this._networkService.get("api/dashboard/user", null, null, "bearer");
  }
  

}
